<template>
  <v-container>
    <h2>Check-in History</h2>
    <v-card>
      <v-row class="ma-2">
        <v-col md="3">
          <v-autocomplete label="Company" :items="companyList" item-text="name_company" v-model="selectedCompany" item-value="id" @change="changeCompany"></v-autocomplete>
        </v-col>

        <v-col md="4" offset="5">
          <div class="mt-4 float-right">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="onWeekChange('prev')">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </template>
              <span>Previous Week</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="onWeekChange('today')">
                  <v-icon>mdi-calendar</v-icon>
                </v-btn>
              </template>
              <span>This Week</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="onWeekChange('next')">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
              <span>Next Week</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <ChartAttendance v-if="!loading" v-bind:companyId="selectedCompany" v-bind:companyName="companyName" v-bind:week="week"></ChartAttendance>
    <v-card v-show="loading">
      <v-row align="center" justify="center" style="height: 350px;">
        <v-progress-circular :size="80" color="primary" indeterminate ></v-progress-circular>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import moment from 'moment'
import ChartAttendance from './components/ChartAttendance'
export default {
  name: "CheckInHistory",
  components: {
    ChartAttendance,
  },
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
      companyList: [],
      selectedCompany: '',
      companyName: '',
      loading: false,
      week: moment().week()
    }
  },
  methods: {
    async onWeekChange(type) {
      switch (type) {
        case 'next':
          this.week++
          break
        case 'prev':
          this.week--
          break
        default:
          this.week = moment().week()
          break
      }
      this.refreshDataAttendance()
    },
    refreshDataAttendance() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 10);
    },
    async getCompanyList() {
      const result = await this.$store.dispatch('getCompanyList')
      const data = []
      if (result) {
        result.map(item => {
          if (item.is_active) {
            data.push(item)
          }
        })
      }
      return data
    },
    changeCompany(id) {
      this.companyName = this.companyList.find(e => {return e.id == id}).name_company
      this.refreshDataAttendance()
    },
  },
  computed: {
  },
  async created() {
    this.companyList = await this.getCompanyList()
  },
  watch: {
  },
};
</script>
